import { render } from "./documentsEditor.vue?vue&type=template&id=958bb19e&scoped=true"
import script from "./documentsEditor.vue?vue&type=script&lang=js"
export * from "./documentsEditor.vue?vue&type=script&lang=js"

import "./documentsEditor.vue?vue&type=style&index=0&id=958bb19e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-958bb19e"]])

export default __exports__